<div class="order-card">
  <div class="oc-main">
    <div class="oc-logo">
      <app-image
        [fileid]="o.bus_type_snapshot.platform.icon"
        [radius]="8"
      ></app-image>
    </div>
    <div class="oc-info">
      <div class="oc-title">{{ o.bus_type_snapshot.platform.name }}</div>
      <div class="oc-spec">
        {{ o.bus_type_snapshot.name }}
        <ng-container *ngIf="o.bus_type_snapshot.group">
          ({{ o.bus_type_snapshot.group }})
        </ng-container>
      </div>
      <div
        class="oc-tag"
        *ngIf="o.bus_type_snapshot.platform.seat_display !== '--'"
      >
        {{ o.exclusive ? "包车" : "拼车" }}
      </div>
    </div>
    <div class="oc-right">
      <div class="oc-status success">
        <app-user-order-status [status]="o.status"></app-user-order-status>
      </div>
      <div class="oc-price"><span>¥</span>{{ o.total_price }}</div>
    </div>
  </div>

  <div class="oc-bottom">
    <div class="oc-date">
      <app-datetime [text]="o.created_time"></app-datetime>
    </div>
    <div class="oc-payinfo">
      <span>实付款: ¥{{ o.total_price }}</span>

      <button class="oc-more-btn" (click)="menu = !menu">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="1.5"></circle>
          <circle cx="19" cy="12" r="1.5"></circle>
          <circle cx="5" cy="12" r="1.5"></circle>
        </svg>
      </button>
      <div
        id="menu-RF-158215"
        class="dropdown-menu"
        [ngStyle]="{ display: menu ? 'flex' : 'none' }"
      >
        <button routerLink="/buy">再次购买</button>
        <!-- <button
          class="brand"
          (click)="openBill(o)"
          *ngIf="
            o.invoiced === 'none' &&
            (o.status === 'Completed' || o.status === 'Paid')
          "
        >
          申请发票
        </button>
        <button
          class="processing"
          *ngIf="o.invoiced === 'processing'"
          (click)="openTip()"
        >
          开票处理中
        </button> -->
        <button class="danger" *ngIf="canRefund" (click)="openRefund()">
          申请退款
        </button>
        <button *ngIf="o.refund_status" (click)="openRefundDetail()">
          查看退款详情
        </button>
      </div>
    </div>
  </div>
</div>
